import { css, SerializedStyles } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';

export const bottomTextContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(${SpacingToken.Spacing4});
`;

export const bottomText: SerializedStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  width: fit-content;
`;

export const button = (disabled?: boolean): SerializedStyles => css`
  color: ${disabled
    ? `var(${DesignToken.ContentBasicDisabled})`
    : `var(${DesignToken.ActionPrimaryDefault})`};

  cursor: ${disabled ? 'not-allowed' : 'pointer'};

  > div {
    margin: 0;
  }
`;
